module.exports = __webpack_public_path__ + "img/foursquare.b4d7f87a.png";